import { createKeyFactory } from '@clouway/query'

export const customersKeys = createKeyFactory('customers')

export const customersSearchKey = (query: string) => customersKeys.custom('search', query)
